import Layout from '@layout/Index'

export const violationAlert = [
  {
    path: '/violation-alert',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "ViolationAlertTable" */ './pages/ViolationAlertTable.vue'),
        name: '违规预警列表',
        meta: {
          title: '违规预警',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "ViolationAlertCreate" */ './pages/ViolationAlertCreate.vue'),
        name: '添加违规预警消息',
        meta: {
          title: '添加违规预警消息',
        },
      },
      {
        path: 'types/create',
        component: () => import(/* webpackChunkName: "ViolationAlertTypeForm" */ './pages/ViolationAlertTypeForm.vue'),
        name: '新增违规类型',
        meta: {
          title: '新增违规类型',
        },
      },
      {
        path: 'types/edit/:id',
        component: () => import(/* webpackChunkName: "ViolationAlertTypeForm" */ './pages/ViolationAlertTypeForm.vue'),
        name: '编辑违规类型',
        meta: {
          title: '编辑违规类型',
        },
      },
      {
        path: 'types',
        component: () => import(/* webpackChunkName: "ViolationAlertTypeTable" */ './pages/ViolationAlertTypeTable.vue'),
        name: '违规类型管理',
        meta: {
          title: '违规类型管理',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "ViolationAlertDetail" */ './pages/ViolationAlertDetail.vue'),
        name: '违规预警发送名单',
        meta: {
          title: '发送名单',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/violation-alert/violation-alert.route.js